import SpeakingTest from "./SpeakingTest";

export default SpeakingTest;
